<template>
	<SimpleModal @close="$emit('close')">
		<div class="container">
			<button
				class="action-button primary block"
				@click="$emit('leave-meeting')"
				@keyup.enter="$emit('leave-meeting')"
				:aria-label="$t('meetings_actionsheet_button_leave_meeting')"
			>
				{{ $t('meetings_actionsheet_button_leave_meeting') }}
			</button>

			<div v-if="isHost" class="divider" />

			<button
				v-if="isHost"
				class="action-button block"
				@click="$emit('stop-videosession')"
				@keyup.enter="$emit('stop-videosession')"
				:aria-label="$t('meetings_actionsheet_button_end_meeting')"
			>
				{{ $t('meetings_actionsheet_button_end_meeting') }}
			</button>
		</div>
	</SimpleModal>
</template>

<script>
import { SimpleModal } from '@/components/common'
import {
	CloseIcon,
	EndMeetingIcon,
	WatchMeetingIcon,
	LeaveMeetingIcon,
} from '@/icons'
import {
	getUserPrefs,
	getCurrentUser,
	getIsHostByUserId,
	getIsCoHostByUserId,
} from './data'

const activeColor = '#5a91f9'
const inactiveColor = '#c6cace'

export default {
	name: 'LeaveMeetingPopup',
	components: {
		SimpleModal,
		CloseIcon,
		EndMeetingIcon,
		WatchMeetingIcon,
		LeaveMeetingIcon,
	},

	data() {
		return {
			camera: true,
			mic: true,
			activeColor,
			inactiveColor,
		}
	},

	emits: ['leave-meeting', 'stop-videosession', 'close'],
	
	mounted() {
		const { video, audio } = getUserPrefs()
		this.camera = video
		this.mic = audio
	},

	computed: {
		isHost() {
			const { id } = getCurrentUser() || {}
			return getIsHostByUserId(id) || getIsCoHostByUserId(id)
		},
	},
}
</script>

<style lang="scss" scoped>
$gray: #c6cace;
$red: #ff525a;
$lightgray: #eeeeee;

.container {
	padding: 35px 50px;
	max-width: 375px;
}

.divider {
	border-top: 1px solid #e2e4e6;
	margin: 16px 0;
	width: 100%;
}

.action-button {
	font-size: 14px;
	padding: 8px 16px;
	border-radius: 20px;
	color: $red;
	background: #ffffff;
	border: 1px solid $red;
	min-width: 275px;
	height: 40px;
	&.primary {
		color: white;
		background: $red;
	}
	&.block {
		display: block;
		width: 100%;
		text-align: center;
	}

	svg {
		vertical-align: top;
		margin-top: 3px;
		margin-right: 5px;
	}
}
</style>
